import angular from 'angular';

import InventoryTransitionsHistoryChainTab from './inventory-transitions-history-chain-tab.component';

export default angular
  .module('inventory-transitions-history-chain-tab', [])
  .component('inventoryTransitionsHistoryChainTab', new InventoryTransitionsHistoryChainTab());



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/inventory-transitions-history-chain-tab/inventory-transitions-history-chain-tab.module.js